// import { Helmet } from 'react-helmet';
import * as firebase from 'firebase';
import { History } from 'history';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import { Route } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from './base/BaseComponent';
import { AuthUser, onAuthStateChanged, ResponseData } from './base/FirebaseInit';
import { BookingCancelationConfirmation } from './new-booking/BookingCancelationConfirmation';

import { BookingVoucher } from './new-booking/BookingVoucher';
import { IndexCMS } from './cms/IndexCMS';
import { WishlistPanel } from './cms/WishlistPanel';
import { COMPANY_INFO, getFirstBrowserLanguage, LOCAL_STORAGE_SEASON, makeid, newI18n, SOCMED_FB, SOCMED_GPLUS, SOCMED_TWTR, SOCMED_YOUTUBE, BHAM_STORAGE_AFFILIATE } from './core/Const';
import { GmapWithBasePanel } from './core/GmapWithBasePanel';
import { ModalWrapper } from './core/index';
import { InThePress } from './core/InThePress';
import { TestimonialPanel } from './core/TestimonialPanel';
import { FooterMain } from './footer/FooterMain';
// import { FooterSection1 } from './footer/FooterSection1';
import { MainHeader } from './header/MainHeader';
import { DefaultPage } from './home/DefaultPage';
import { HotelSattlementEnquiry } from './hotels/HotelSattlementEnquiry';
import { HotelSearchResultWithUrlReqKeyMainPanel } from './hotels/HotelSearchResultWithUrlReqKeyMainPanel';
// import { HotelSearchResultMainPanelWithBulkData } from './hotels/HotelSearchResultMainPanelWithBulkData';
import { AccountLeftSide } from './my-account/AccountLeftSide';
import { MyBooking } from './my-account/MyBooking';
import { MyProfile } from './my-account/MyProfile';
import { MyReview } from './my-account/MyReview';
import { MyReward } from './my-account/MyReward';
import { MyWishlist } from './my-account/MyWishlist';
import { HotelBedData, SecurityData } from './shared/index';
import { InterestFreeHolidays } from './static-content/InterestFreeHolidays';
import { StaticContentIndex } from './static-content/StaticContentIndex';
import { getJsonFromUrl } from './utils/campursari';
import { isNull } from './utils/index';
import { updateLanguageWindow } from './utils/master-data-adapter';
import { sendHotelAvailibilityRequest } from './utils/req-available-helper';
import { OneDolarDeposit } from './my-account/OneDolarDeposit';
import { BookingMainPanelNew } from './new-booking/BookingMainPanelNew';
import { BookingCheckout } from './new-booking/BookingCheckout';
import { BookingChecoutProgressPanel } from './new-booking/BookingChecoutProgressPanel';
import { GrandMirage } from './static-content/GrandMirage';
import { BaliDynasty } from './static-content/BaliDynasty'; 
import { BaliBestBudgetHotel } from './static-content/BaliBestBudgetHotel';
const topHeaderData = {
    companyInfo: COMPANY_INFO,
    socialMedia: [SOCMED_TWTR, SOCMED_FB, SOCMED_GPLUS, SOCMED_YOUTUBE]
};

export const defaultSetting = {
    "localhost": {
        lang: "ENG", currency: "IDR"
    },
    "balihotelsandmore.co.id": {
        lang: "IND", currency: "IDR"
    },
    "www.balihotelsandmore.co.id": {
        lang: "IND", currency: "IDR"
    },
    "www.balihotelsandmore.com": {
        lang: "ENG", currency: "AUD"
    },
    "balihotelsandmore.com": {
        lang: "ENG", currency: "AUD"
    },
    "www.balihotelsandmore.com.au": {
        lang: "ENG", currency: "AUD"
    },
    "balihotelsandmore.com.au": {
        lang: "ENG", currency: "AUD"
    },
    "www.topbalihotels.com": {
        lang: "JPN", currency: "JPY"
    },
    "topbalihotels.com": {
        lang: "JPN", currency: "JPY"
    },
};

export interface DefMapCenter {
    lat: number;
    lng: number;
}

export interface DynamicRouteData {
    id: number;
    destCode: string;
    zoneCode: string;
    slug: string;
}

export interface HotelApplicationProps extends BaseComponentProps {
    /**
     * path app
     */
    currentAppPath: string;

    /** 
     * access ke router history
     */
    history: History;
    firebaseApp: firebase.app.App;
    realtimeDb: firebase.database.Database;
    // userLoginFlag: boolean;
    userLogin: SecurityData.ApplicationUser | null;
}
export interface HotelApplicationState extends BaseComponentState {
    lang: string;
    currency: string;
    // user: SecurityData.ApplicationUser;
    userLogin: SecurityData.ApplicationUser | null;
    userNonAnonimLoginFlag: boolean;
    userDialogOpen: boolean;
    defMapCenter: DefMapCenter;
    exchangeRate: number;
    mapZoom: number;
    /**
     * search filter dari current data
     */
    currentSearchData: {
        /**
         * filter data hotel
         */
        filter?: HotelBedData.SearchFilter;

        /**
         * external filter. ini di pakai filter areal, tipe
         */
        externalFilter?: HotelBedData.ExternalFilter;
        /**
         * page untuk di request di awal
         */
        page: number;
    };
    /**
     * ukuran page per searching
     */
    pageSize: number;

    wishlistCount: number;

    popUpOpen: boolean;

    enableChengeCurrency: boolean;

    /** Perubahan untuk query string  */
    responKey: string;

    fbAccount: AuthUser;
    // masterPage: string;
    uuid: string;

    langData: any;

    userAccess: string;
}

/** 
 * main panel dari app
 */
export class HotelApplication extends BaseComponent<HotelApplicationProps, HotelApplicationState> {

    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['currentAppPath'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ['currency', 'lang', 'userLogin', 'userDialogOpen', 'wishlistCount', 'responKey', 'popUpOpen'];
    curSeasonstorage: string = btoa("currency_default");
    hotelMainPanel: HotelSearchResultWithUrlReqKeyMainPanel;

    constructor(props: HotelApplicationProps) {
        super(props);
        // let empty: any = {};
        // let a = localStorage.getItem(`${LOCAL_STORAGE_SEASON}user`);
        let cur = 'AUD';
        let langCode: string = getFirstBrowserLanguage();
        let def = defaultSetting[window.location.hostname];
        if (def) {
            cur = def.currency;
            langCode = def.lang;
        }
        let newCur = localStorage.getItem(`${LOCAL_STORAGE_SEASON}${this.curSeasonstorage}`);
        if (newCur) {
            cur = newCur;
        } else {
            localStorage.setItem(`${LOCAL_STORAGE_SEASON}${this.curSeasonstorage}`, cur);
        }

        /*
        let whs = localStorage.getItem(LOCAL_STORAGE_KEY_WISHLIST);
        if (whs) {
            let wh: any =  JSON.parse(whs);
            sessionStorage.setItem(BHAM_STORAGE_WISHLIST, wh.code );
        }
        */
        // let wishlistID = sessionStorage.getItem(BHAM_STORAGE_WISHLIST) ? sessionStorage.getItem(BHAM_STORAGE_WISHLIST) : null;
        let param: any = getJsonFromUrl(this.props.history.location.search);
        let page = 0;
        let rk = '';
        if (param && param.rk && param.page) {
            page = param.page;
            rk = param.rk;
        }
        let currentSrc: any = {
            count: 0,
            page: page / 1
        };
        this.goMain();
        updateLanguageWindow(langCode);

        this.state = {
            pageSize: 15,
            lang: langCode,
            userNonAnonimLoginFlag: false,
            currency: cur,
            userDialogOpen: false,
            currentSearchData: currentSrc,
            wishlistCount: 0,
            exchangeRate: 1,
            userLogin: {},
            popUpOpen: false, defMapCenter: { lat: -8.3762265, lng: 115.1946753 }, mapZoom: 10,
            enableChengeCurrency: true,
            responKey: rk,
            fbAccount: {},
            uuid: "",
            langData: {},
            userAccess: "GUEST"
        };
        console.log("hotelMainPanel", this.hotelMainPanel);
    }

    goMain = () => {
        if (window.history && window.history.pushState) {
            $(window).on('popstate', () => {
                if (this.props.history && this.props.history.location && this.props.history.location.pathname === '/hotels') {
                    let param: any = getJsonFromUrl(this.props.history.location.search);
                    this.setStateHelper(
                        (st) => {
                            st.responKey = param.rk;
                            st.currentSearchData.page = param.page;
                        },
                        () => {
                            this.hotelMainPanel.actionChangePage(param.page, "Dari Back");
                        }
                    );

                }

                // alert(param);
                // console.log(param, this.props.history.location.pathname);
            });
        }
    }

    shouldComponentUpdate(nextProps: HotelApplicationProps, nextState: HotelApplicationState): boolean {

        if (this.compareForShouldComponentUpdateStateOrProp(HotelApplication.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(HotelApplication.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;

    }
    rateChanged: (rate: number) => any = (rate: number) => {
        this.setState({ exchangeRate: rate });
    }

    userAccessChange = (userAccess: string) => {
        this.setState({ userAccess });
    }
    /** 
     * handler kalau tombol login di click 
     */
    onLoginButtonClick: () => any = () => {
        this.setState({ userDialogOpen: true });
    }

    /** 
     * handler kalau di pilih tutup login dialog
     */
    onCloseLoginDialogClick: () => any = () => {
        this.setState({ userDialogOpen: false });
    }

    componentDidMount() {
        onAuthStateChanged(this.props.firebaseApp).then(
            (e: ResponseData<AuthUser>) => {
                if (e) {
                    if (e.haveError === false) {
                        console.log(JSON.stringify(e));
                        let anonimousUser = true;
                        if (e.data!.providerData!.length !== 0) {
                            anonimousUser = false;
                        }
                        this.setStateHelper(
                            st => {
                                st.fbAccount = e.data!;
                                st.userNonAnonimLoginFlag = !anonimousUser;
                                st.userLogin = this.props.userLogin;
                                st.uuid = this.props.userLogin!.uuid!;
                            });
                    } else {
                        console.log(e.errorMessage);
                    }
                }
            }
        ).catch(
            err => {
                console.log(err);
            }
        );

    }
    updateMapCenter: (data: DefMapCenter, mapZoom: number) => any = (data: DefMapCenter, mapZoom: number) => {
        this.setStateHelper(
            st => {
                st.defMapCenter = data;
                st.mapZoom = 10;
            }
        );
    }

    /**
     * kalau currency ganti
     * @param cur kode currency baru
     */
    onCurrencyChange: (cur: string) => any = (cur: string) => {
        this.setState({ currency: cur }, () => {
            localStorage.setItem(`${LOCAL_STORAGE_SEASON}${this.curSeasonstorage}`, cur);
        });
    }

    onLanguageChange: (lang: string) => any = (lang: string) => {
        updateLanguageWindow(lang).then(
            () => {
                this.setStateHelper(
                    st => {
                        st.lang = lang;
                        window['lang-code'] = lang;
                        // TODO: Simpen ke server di table sec_user
                    }
                );
            }
        );
    }

    openPopup: () => any = () => {
        console.log("Modal Banner di Buka");
        this.setStateHelper(
            st => { st.popUpOpen = true; }
        );
    }
    hengleDialogClose: () => any = () => {
        console.log("Modal Banner di Tutup");
        this.setStateHelper(st => { st.popUpOpen = false; });
    }

    changeCurrenct: (e: boolean) => any = (e: boolean) => {
        this.setState({ enableChengeCurrency: e });
    }
    newRequestAvailability: (dari: string) => any = (dari: string) => {
        console.log("newRequestAvailability dari: ", dari);

        sendHotelAvailibilityRequest({ filter: this.state.currentSearchData.filter!, app: this.props.firebaseApp }).then((dataKey: any) => {
            this.setState({ responKey: dataKey.responKey }, () => {
                this.props.history.push(`/hotels?rk=${this.state.responKey}&page=${this.state.currentSearchData.page}`);
            });
        }).catch((exc) => { console.error('error: ', exc); });
    }
    pageChange: (page: number, dari: string) => any = (page: number, dari: string) => {
        console.log("hotelMainPanel", this.hotelMainPanel);
        this.setStateHelper(
            st => {
                console.log("Page Change Dari", dari);
                st.currentSearchData.page = page;
            },
            () => {
                // this.newRequestAvailability("Page Change");
                let rk = this.state.responKey;
                if (!this.state.responKey && rk.length === 0) {
                    rk = window["responKey"];
                }
                this.props.history.push(`/hotels?rk=${rk}&page=${this.state.currentSearchData.page}`);
                if (!this.hotelMainPanel) {
                    this.hotelMainPanel = window["hotelMainPanel"];
                }
                this.hotelMainPanel.actionChangePage(page, dari);
            }
        );
    }
    render(): JSX.Element {
        console.log("hotelMainPanel", this.hotelMainPanel);
        console.log("State Sekarang", this.state);
        let pa: any = getJsonFromUrl(this.props.history.location.search);
        let aff = "";
        // let id = 0;
        if (pa) {
            if (pa.aff_id) {
                aff = pa.aff_id;
                localStorage.setItem(BHAM_STORAGE_AFFILIATE, aff);
            }
        }
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        // let seoContent: SecurityData.SEOContent = COMPANY_SEO;
        let footera: any[] = [];

        footera.push(
            <TestimonialPanel slideNumber={2} backgroundImage="https://storage.googleapis.com/bali-hotel-images/background/testimonial-bg-dark.jpg" template="N-TESTI-SLIDER-DARK" />
        );
        footera.push(
            <InThePress />
        );
        let extFilter: any = !isNull(this.state.currentSearchData) ? this.state.currentSearchData.externalFilter : null;
        // console.log("this.props.history.location", his);
        let style: ReactModal.Styles = {
            overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0, 0.75)', zIndex: 9999 },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: 'rgba(0,0,0,0)',
                border: 0
            }
        };
        return (
            <div>
                <Helmet title={newI18n("SEO.title", "Bali Hotels and More Have Over 1600 Of Bali’s Best Hotel Options. Find The Perfect Hotel Now.")} >
                    <meta charSet="utf-8" />
                    <meta name="description" content={newI18n("SEO.title", "$1 Deposit Hotels And Pay 2 Weeks Before You Arrive In Bali -Up To 40% Off Some Of Bali’s Best Hotels. Free Transfers And Free Tours When You Book. Chat To Our Team Live Now.")} />
                    <meta name="keywords" content={newI18n("SEO.title", "bali hotel")} />
                </Helmet>
                <MainHeader
                    firebaseApp={this.props.firebaseApp}
                    key={`MainHeader-${this.state.lang}-${this.state.currency}`}
                    topHeaderData={topHeaderData}
                    currency={this.state.currency}
                    lang={this.state.lang}
                    user={this.state.userLogin!}
                    currencyChange={this.onCurrencyChange}
                    user_login={this.state.userNonAnonimLoginFlag}
                    languageChange={this.onLanguageChange}
                    accountHandleClick={this.onLoginButtonClick}
                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                    userDialogOpen={this.state.userDialogOpen}
                    wishlistCount={this.state.wishlistCount}
                    changeCurrency={this.state.enableChengeCurrency}
                    history={this.props.history}
                    userAccess={this.state.userAccess}
                />
                <ModalWrapper
                    key={`nama` + this.state.popUpOpen}
                    style={style}
                    isOpen={this.state.popUpOpen}
                    onRequestClose={this.hengleDialogClose}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                >
                    <div className="show-popup-detail">
                        <button style={{ padding: '5px 10px', background: '#000', borderRadius: '50%', float: 'right' }} onClick={this.hengleDialogClose}>x</button>
                        <img src="https://storage.googleapis.com/bali-hotel-images/1-dolar-deposit-1080.jpg" width='100%' />
                    </div>
                </ModalWrapper>
                <div className="app-content" key={'root' + this.state.lang + this.state.currency}>
                    <section style={{ minHeight: 500 }}>
                        {/*default route */}
                        <Route path="/" exact={true} render={this.rendererDefaultRoutePanel} />
                        <Route path="/index.html" exact={true} render={this.rendererDefaultRoutePanel} />
                        {this.renderVoucherConfirmed()}
                        {this.renderVoucherCancelationConfirmation()}
                        {this.renderAccountRoutes()}
                        {this.renderHotelPath()}
                        {this.HotelBooking()}
                        {this.renderWishlist()}
                        {this.bookingCheckout()}
                        <Route
                            path='/settlement'
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    return (
                                        <div  >
                                            <HotelSattlementEnquiry history={props.history as any} />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/interest-free-holidays"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <InterestFreeHolidays
                                                lang={this.state.lang}
                                                history={props.history as any}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/grand-mirage-hotel-an-all-inclusive-bali-luxury-resort"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div >
                                            <GrandMirage
                                                lang={this.state.lang}
                                                history={props.history as any}
                                            />
                                        </div>
                                    );
                                }
                            }
                        /> 
                        <Route
                            path="/bali-dynasty-resort-hotels"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    return (
                                        <div >
                                            <BaliDynasty
                                                lang={this.state.lang}
                                                history={props.history as any}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/best-budget-hotel-in-bali"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div >
                                            <BaliBestBudgetHotel
                                                lang={this.state.lang}
                                                history={props.history as any}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/news"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'news'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/contact-us"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'contact-us'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/request-cancelation"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'request-cancelation'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />

                        <Route
                            path='/maps'
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    let param: any = getJsonFromUrl(props.history.location.search);
                                    let rk = "";
                                    let id = 0;
                                    if (param) {
                                        if (param.rk) {
                                            rk = param.rk;
                                        }
                                        if (param.id) {
                                            id = param.id;
                                        }
                                    }
                                    return (
                                        <div  >
                                            <GmapWithBasePanel
                                                // key={this.state.lang + this.state.currency + rk + plusrk}
                                                lang={this.state.lang}
                                                currency={this.state.currency}
                                                style={{ width: '100%', height: '100vh' }}
                                                responKey={rk}
                                                defMapCenter={this.state.defMapCenter}
                                                mapZoom={this.state.mapZoom}
                                                updateMapCenter={this.updateMapCenter}
                                                wishlistCount={this.wishListCount}
                                                idHotels={id}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/privacy-policy"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'privacy-policy'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/modification-booking"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'modification-booking'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/terms-of-use"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'terms-of-use'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/settlement-thankyou"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'settlement-thankyou'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/sitemap"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'sitemap'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/faqs"
                            exact={true}
                            render={
                                (props: RouteComponentProps<any>) => {
                                    // console.log("Slug", props);
                                    return (
                                        <div  >
                                            <StaticContentIndex
                                                slug={'faqs'}
                                                lang={this.state.lang}
                                                history={props.history as any}
                                                externalFilter={extFilter}
                                                getHotels={this.getHolderWorker}
                                                initialFilter={this.state.currentSearchData.filter}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/:slug"
                            render={
                                (props: RouteComponentProps<any>) => {
                                    let param: any = getJsonFromUrl(props.history.location.search);
                                    let rk = "";
                                    let reqaid = 0;
                                    let night = '';
                                    // let id = 0;
                                    if (param) {
                                        if (param.rk) {
                                            rk = param.rk;
                                        }
                                        if (param.rk) {
                                            reqaid = param.reqaid;
                                        }
                                        if (param.night) {
                                            night = param.night;
                                        }
                                    }
                                    return (
                                        <div key={makeid()}>
                                            <IndexCMS
                                                slug={props.match.params.slug}
                                                lang={this.state.lang}
                                                currency={this.state.currency}
                                                pageSize={15}
                                                history={props.history as any}
                                                wishlistCount={this.wishListCount}
                                                getHotels={this.getHolderWorker}
                                                userLogin={this.state.userLogin!}
                                                initialFilter={this.state.currentSearchData.filter!}
                                                responKey={rk}
                                                updateInternalFilter={this.updateInternalFilter}
                                                uuid={this.state.uuid}
                                                firestoreDb={this.props.firebaseApp.firestore()}
                                                realtimeDb={this.props.realtimeDb}
                                                newRequestAvailability={this.newRequestAvailability}
                                                firebaseApp={this.props.firebaseApp}
                                                reqAvailableDetailId={reqaid!}
                                                night={night}
                                                pageChange={this.pageChange}
                                                page={this.state.currentSearchData.page}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        <Route
                            path="/bali-weddings/:slug"
                            render={
                                (props: RouteComponentProps<any>) => {
                                    let param: any = getJsonFromUrl(props.history.location.search);
                                    let rk = "";
                                    let reqaid = 0;
                                    let night = '';
                                    // let id = 0;
                                    if (param) {
                                        if (param.rk) {
                                            rk = param.rk;
                                        }
                                        if (param.rk) {
                                            reqaid = param.reqaid;
                                        }
                                        if (param.night) {
                                            night = param.night;
                                        }
                                    }
                                    return (
                                        <div key={makeid()}>
                                            <IndexCMS
                                                slug={props.match.params.slug}
                                                lang={this.state.lang}
                                                currency={this.state.currency}
                                                pageSize={15}
                                                history={props.history as any}
                                                wishlistCount={this.wishListCount}
                                                getHotels={this.getHolderWorker}
                                                userLogin={this.state.userLogin!}
                                                initialFilter={this.state.currentSearchData.filter!}
                                                responKey={rk}
                                                updateInternalFilter={this.updateInternalFilter}
                                                uuid={this.state.uuid}
                                                firestoreDb={this.props.firebaseApp.firestore()}
                                                realtimeDb={this.props.realtimeDb}
                                                newRequestAvailability={this.newRequestAvailability}
                                                firebaseApp={this.props.firebaseApp}
                                                reqAvailableDetailId={reqaid!}
                                                night={night}
                                                pageChange={this.pageChange}
                                                page={this.state.currentSearchData.page}
                                            />
                                        </div>
                                    );
                                }
                            }
                        />
                        {this.testRender()}
                        {this.BookingChecoutProgressPanel()}
                    </section>
                    {footera}
                    <FooterMain lang={this.state.lang} />

                </div>
            </div>
        );

    }

    BookingChecoutProgressPanel() {
        return (
            <Route
                key='booking-progress'
                exact={true}
                path="/booking-progress"
                render={
                    (props: RouteComponentProps<any>) => {
                        let param: any = getJsonFromUrl(props.history.location.search);

                        let id = 0;
                        // let id = 0;
                        if (param) {
                            if (param.id) {
                                id = param.id / 1;
                            }
                        }
                        return (
                            <div className="container">
                                <BookingChecoutProgressPanel
                                    history={this.props.history}
                                    checkoutId={id}
                                    database={this.props.realtimeDb}
                                />

                            </div>

                        );
                    }
                }
            />
        );

    }

    testRender() {
        return (
            <Route
                key='test-render'
                exact={true}
                path="/test-render"
                render={
                    (props: RouteComponentProps<any>) => {
                        return (
                            <div className="container">
                                <BookingChecoutProgressPanel
                                    history={this.props.history}
                                    checkoutId={171}
                                    database={this.props.realtimeDb}
                                />

                            </div>

                        );
                    }
                }
            />
        );

    }
    bookingCheckout() {
        return (
            <Route
                key='booking-checkout'
                exact={true}
                path="/booking-checkout"
                render={
                    (props: RouteComponentProps<any>) => {
                        console.log("renderVoucherConfirmed", props);
                        let param: any = getJsonFromUrl(props.history.location.search);
                        let checkoutId = "";
                        if (param) {
                            if (param.id) {
                                checkoutId = param.id;
                            }
                        }
                        return (
                            <BookingCheckout history={this.props.history} lang={this.state.lang} uuid={this.state.uuid} checkoutId={checkoutId as any / 1} firebaseApp={this.props.firebaseApp} />
                        );
                    }
                }
            />
        );
    }
    renderVoucherConfirmed() {
        return (
            <Route
                key='voucher-confirme'
                exact={true}
                path="/voucher-confirmed"
                render={
                    (props: RouteComponentProps<any>) => {
                        console.log("renderVoucherConfirmed", props);
                        let param: any = getJsonFromUrl(props.history.location.search);
                        let bookingId = "";
                        if (param) {
                            if (param.id) {
                                bookingId = param.id;
                            }
                        }
                        return (
                            <BookingVoucher userLogin={this.state.userLogin!} bookingId={bookingId} />
                        );
                    }
                }
            />
        );
    }

    renderVoucherCancelationConfirmation() {
        return (
            <Route
                key='voucher-confirme-cancelation'
                exact={true}
                path="/voucher-cancelation-confirmation"
                render={
                    (props: RouteComponentProps<any>) => {
                        console.log("renderVoucherConfirmed", props);
                        let param: any = getJsonFromUrl(props.history.location.search);
                        let bookingId = "";
                        if (param) {
                            if (param.id) {
                                bookingId = param.id;
                            }
                        }
                        return (
                            <BookingCancelationConfirmation bookingId={bookingId} lang={this.state.lang} getHotels={this.getHolderWorker} initialFilter={this.state.currentSearchData.filter!} />
                        );
                    }
                }
            />
        );
    }
    renderWishlist() {
        return (
            <Route
                key={'wishlist'}
                exact={true}
                path="/wishlist"
                render={
                    (props: RouteComponentProps<any>) => {
                        console.log("renderWishlist", props);
                        let param: any = getJsonFromUrl(props.history.location.search);
                        let id = "";
                        if (param) {
                            if (param.id) {
                                id = param.id;
                            }
                        }
                        // sessionStorage.setItem(BHAM_STORAGE_WISHLIST, id);
                        return (
                            <WishlistPanel
                                key={'wishlist_' + this.state.lang + this.state.currency}
                                id={id}
                                lang={this.state.lang}
                                currency={this.state.currency}
                                pageSize={15}
                                history={props.history}
                                wishlistCount={this.wishListCount}
                                getHotels={this.getHolderWorker}
                                initialFilter={this.state.currentSearchData.filter!}
                                uuid={this.state.uuid}
                                firestoreDb={this.props.firebaseApp.firestore()}
                                realtimeDb={this.props.realtimeDb}
                                updateInternalFilter={this.updateInternalFilter}
                                newRequestAvailability={this.newRequestAvailability}
                                firebaseApp={this.props.firebaseApp}
                                pageChange={this.pageChange}
                                page={this.state.currentSearchData.page}
                            />
                        );
                    }
                }
            />
        );
    }

    /**
     * default route. untuk / dan welcome page
     */
    private rendererDefaultRoutePanel: (props: RouteComponentProps<any>) => JSX.Element = (props: RouteComponentProps<any>) => {
        return (
            <DefaultPage
                user={this.state.userLogin!}
                user_login={this.state.userNonAnonimLoginFlag}
                lang={this.state.lang}
                currency={this.state.currency}
                getHotels={this.getHolderWorker}
                history={props.history}
                initialFilter={this.state.currentSearchData.filter!}
            />);
    }

    /**
     * worker untuk search hotel
     */
    private getHolderWorker: (
        lang: string,
        page: number,
        count: number,
        filter: HotelBedData.SearchFilter,
        externalFilter: HotelBedData.ExternalFilter,
        history?: string) => any = (
            lang: string, page: number, count: number, filter: HotelBedData.SearchFilter,
            externalFilter: HotelBedData.ExternalFilter, history?: string) => {
            this.setStateHelper(
                st => {
                    st.currentSearchData = {
                        externalFilter: externalFilter,
                        filter: filter,
                        page: page
                    };
                },
                () => {

                    this.newRequestAvailability("Dari HotelApplication getHolderWorker");
                });

        }

    private HotelBooking(): JSX.Element {

        return (
            <Route
                key='booking'
                exact={true}
                path="/booking"
                render={
                    (props: RouteComponentProps<any>) => {

                        let param: any = getJsonFromUrl(props.history.location.search);
                        let rk = "";
                        let id = 0;
                        let bn = 0;
                        if (param) {
                            if (param.rk) {
                                rk = param.rk;
                            }
                            if (param.id) {
                                id = param.id;
                            }
                            if (param.bn === "1") {
                                bn = 1;
                            }
                        }
                        /*
                        if (window['fbq']) {
                            window['fbq']('track', 'AddToCart', {
                                content_name: 'booking',
                                content_type: 'product',
                                content_ids: [id],
                                contents: [{id: id, rk: rk}]
                            });
                        }
                        */
                        return (
                            <BookingMainPanelNew
                                history={this.props.history}
                                firebaseApp={this.props.firebaseApp}
                                currencyCode={this.state.currency}
                                lang={this.state.lang}
                                roomCheckoutId={id}
                                reqKey={rk}
                                bookNow={bn}
                                classright={''}
                            />
                        );

                    }
                }
            />
        );
    }

    private wishListCount: (c: number) => any = (c: number) => {
        console.warn("wishListCount Dipanggil");
        this.setStateHelper(st => {
            st.wishlistCount = st.wishlistCount + c;
        });

    }
    private hotelRenderer: (props: RouteComponentProps<any>) => JSX.Element = (props: RouteComponentProps<any>) => {
        let initFilter: any = !isNull(this.state.currentSearchData) ? this.state.currentSearchData.filter : null;
        let extFilter: any = !isNull(this.state.currentSearchData) ? this.state.currentSearchData.externalFilter : null;

        if (window['fbq']) {
            window['fbq']('track', 'Search', {
                content_name: 'hotels',
                content_type: 'html',
            });
        }
        let param: any = getJsonFromUrl(props.history.location.search);
        let rk = "";
        if (param) {
            if (param.rk) {
                rk = param.rk;
            }
        }
        // console.log("initialFilter ", initFilter );
        return (
            <HotelSearchResultWithUrlReqKeyMainPanel
                ref={d => this.hotelMainPanel = d as any}
                key={`htseacth${rk}`}
                initialFilter={initFilter}
                initialExternalFilter={extFilter}
                pageSize={15}
                lang={this.state.lang}
                currency={this.state.currency}
                history={props.history}
                wishlistCount={this.wishListCount}
                responKey={rk}
                newRequestAvailability={this.newRequestAvailability}
                getHotels={this.getHolderWorker}
                updateInternalFilter={this.updateInternalFilter}
                uuid={this.state.uuid}
                firestoreDb={this.props.firebaseApp.firestore()}
                realtimeDb={this.props.realtimeDb}
                firebaseApp={this.props.firebaseApp}
                pageChange={this.pageChange}
                page={this.state.currentSearchData.page}
            />);
    }
    private renderHotelPath(): JSX.Element[] {
        if (!this.props.currentAppPath.startsWith('/hotels')) {
            return [];
        }
        let htlRoute: any = (
            <Route
                key='hotel'
                exact={true}
                path="/hotels"
                render={this.hotelRenderer}
            />
        );
        return [
            htlRoute
        ];
    }

    private updateInternalFilter: (filter: HotelBedData.SearchFilter) => any = (filter: HotelBedData.SearchFilter) => {
        console.log("updateInternalFilter dipanggil");
        this.setStateHelper(st => {
            st.currentSearchData.filter = filter;
        });
    }
    /** 
     * router account  +sub nya
     */
    private renderAccountRoutes(): JSX.Element[] {
        let myAcctRoute: any = (
            <Route
                key='my-account'
                path={`/my-account`}
                exact={true}
                render={(props: RouteComponentProps<any>) => {
                    return (
                        <div style={{ paddingTop: 140 }}>
                            <div className="container">
                                <AccountLeftSide
                                    firebaseApp={this.props.firebaseApp}
                                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                                    lang={this.state.lang}
                                    user={this.state.userLogin!}
                                    user_login={this.state.userNonAnonimLoginFlag}
                                    userAccess={this.state.userAccess}
                                    key={`accountMenu${this.state.userAccess}`}
                                />
                                <div className="col-md-9" style={{ minHeight: 500 }}>
                                    <MyProfile
                                        key='my-acct'
                                        lang={this.state.lang}
                                        user={this.state.userLogin!}
                                        user_login={this.state.userNonAnonimLoginFlag}
                                        userAccessChange={this.userAccessChange}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }}
            />
        );
        let myBookingRoute: any = (
            <Route
                key='/my-account/my-booking'
                path={`/my-account/my-booking`}
                render={(props: RouteComponentProps<any>) => {
                    return (
                        <div style={{ paddingTop: 140 }}>
                            <div className="container">
                                <AccountLeftSide
                                    firebaseApp={this.props.firebaseApp}
                                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                                    lang={this.state.lang}
                                    user={this.state.userLogin!}
                                    user_login={this.state.userNonAnonimLoginFlag}
                                    userAccess={this.state.userAccess}
                                    key={`accountMenu${this.state.userAccess}`}
                                />
                                <div className="col-md-9" style={{ minHeight: 500 }}>
                                    <MyBooking
                                        key='my-acct'
                                        lang={this.state.lang}
                                        user={this.state.userLogin!}
                                        user_login={this.state.userNonAnonimLoginFlag}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }}
            />
        );
        let router2: any = (
            <Route
                key='/my-account/my-reviews'
                path={`/my-account/my-reviews`}
                render={(props: RouteComponentProps<any>) => {
                    return (
                        <div style={{ paddingTop: 140 }}>
                            <div className="container">
                                <AccountLeftSide
                                    firebaseApp={this.props.firebaseApp}
                                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                                    lang={this.state.lang}
                                    user={this.state.userLogin!}
                                    user_login={this.state.userNonAnonimLoginFlag}
                                    userAccess={this.state.userAccess}
                                    key={`accountMenu${this.state.userAccess}`}
                                />
                                <div className="col-md-9" style={{ minHeight: 500 }}>
                                    <MyReview
                                        key='my-acct'
                                        lang={this.state.lang}
                                        user={this.state.userLogin!}
                                        user_login={this.state.userNonAnonimLoginFlag}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }}
            />
        );
        let route3: any = (
            <Route
                key='/my-account/my-rewards'
                path={`/my-account/my-rewards`}
                render={(props: RouteComponentProps<any>) => {
                    return (
                        <div style={{ paddingTop: 140 }}>
                            <div className="container">
                                <AccountLeftSide
                                    firebaseApp={this.props.firebaseApp}
                                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                                    lang={this.state.lang}
                                    user={this.state.userLogin!}
                                    user_login={this.state.userNonAnonimLoginFlag}
                                    userAccess={this.state.userAccess}
                                    key={`accountMenu${this.state.userAccess}`}
                                />
                                <div className="col-md-9" style={{ minHeight: 500 }}>
                                    <MyReward
                                        lang={this.state.lang}
                                        user={this.state.userLogin!}
                                        user_login={this.state.userNonAnonimLoginFlag}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }}
            />
        );
        let route4: any = (
            <Route
                key='/my-account/my-wishlist'
                path={`/my-account/my-wishlist`}
                render={(props: RouteComponentProps<any>) => {
                    return (
                        <div style={{ paddingTop: 140 }}>
                            <div className="container">
                                <AccountLeftSide
                                    firebaseApp={this.props.firebaseApp}
                                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                                    lang={this.state.lang}
                                    user={this.state.userLogin!}
                                    user_login={this.state.userNonAnonimLoginFlag}
                                    userAccess={this.state.userAccess}
                                    key={`accountMenu${this.state.userAccess}`}
                                />
                                <div className="col-md-9" style={{ minHeight: 500 }}>
                                    <MyWishlist
                                        lang={this.state.lang}
                                        user={this.state.userLogin!}
                                        user_login={this.state.userNonAnonimLoginFlag}
                                        userAccess={this.state.userAccess}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }}
            />);
        let route5: any = (
            <Route
                key='/my-account/my-1-dolar-deposit'
                path={`/my-account/my-1-dolar-deposit`}
                render={(props: RouteComponentProps<any>) => {
                    return (
                        <div style={{ paddingTop: 140 }}>
                            <div className="container">
                                <AccountLeftSide
                                    firebaseApp={this.props.firebaseApp}
                                    hengleUserDialogClose={this.onCloseLoginDialogClick}
                                    lang={this.state.lang}
                                    user={this.state.userLogin!}
                                    user_login={this.state.userNonAnonimLoginFlag}
                                    userAccess={this.state.userAccess}
                                    key={`accountMenu${this.state.userAccess}`}
                                />
                                <div className="col-md-9" style={{ minHeight: 500 }}>
                                    <OneDolarDeposit
                                        lang={this.state.lang}
                                        user={this.state.userLogin!}
                                        user_login={this.state.userNonAnonimLoginFlag}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }}
            />);
        return [myAcctRoute, myBookingRoute, router2, route3, route4, route5];
    }

} 


// WEBPACK FOOTER //
// ./src/HotelApplication.tsx